import api from "./Api";

class SoftwareHouseService {
  GetSoftwareHouse(payload) {
    return api.get("/v1/softwareHouse/" + payload).then((response) => {
      return response.data;
    });
  }

  PostSoftwareHouse(payload) {
    return api.post("/v1/softwareHouse/", payload).then((response) => {
      return response.data;
    });
  }

  PutSoftwareHouse(payload) {
    return api.put("/v1/softwareHouse/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteSoftwareHouse(payload) {
    return api.delete("/v1/softwareHouse/" + payload).then((response) => {
      return response.data;
    });
  }

  GetSoftwareHouseOData(payload) {
    return api.get("/OData/SoftwareHouse" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new SoftwareHouseService();
